import { FormLabel, FormLabelProps } from '@chakra-ui/react';
import React from 'react';

import { CmText } from '@/components/uiParts';

type Props = {
  isRequired?: boolean;
} & FormLabelProps;

export const CmFormLabel: React.FC<Props> = ({
  children,
  id,
  isRequired = false,
  ...rest
}) => {
  return (
    // @ts-ignore TS2590
    <FormLabel mr={0} htmlFor={id} {...rest}>
      {children}
      {isRequired && (
        <CmText as="span" color="red" fontSize="14px" verticalAlign="super">
          *
        </CmText>
      )}
    </FormLabel>
  );
};
